<template>
    <!-- 안건 42 (2026-05-11): pageTitle 없으면 빈 컨테이너도 렌더 X (상세페이지처럼 일반 page-header off 케이스 대응)
         안건 83 (2026-05-14): pageUrl 있으면 헤딩 전체를 anchor 로 감싸 메뉴 기본 URL 진입 (검색필터 미적용 기본 조회) -->
    <div v-if="pageTitle" class="ref020-page-header">
        <h1 class="ref020-page-header-title">
            <a v-if="pageUrl"
               :href="pageUrl"
               class="ref020-page-header-link"
               :title="pageTitle + ' — 기본 조회로 이동 (검색 조건 초기화)'">
                <i v-if="pageIcon && pageIconType === 'material'" class="material-icons ref020-page-header-icon-mat">{{ pageIcon }}</i>
                <img v-else-if="pageIcon && pageIconType === 'img'" :src="pageIcon" :alt="pageTitle" class="ref020-page-header-icon-img" />
                <span class="ref020-page-header-text">{{ pageTitle }}</span>
            </a>
            <template v-else>
                <i v-if="pageIcon && pageIconType === 'material'" class="material-icons ref020-page-header-icon-mat">{{ pageIcon }}</i>
                <img v-else-if="pageIcon && pageIconType === 'img'" :src="pageIcon" :alt="pageTitle" class="ref020-page-header-icon-img" />
                <span class="ref020-page-header-text">{{ pageTitle }}</span>
            </template>
        </h1>
    </div>
</template>

<script>
// REF-020 Phase 2-D — 페이지 헤더 SSOT Vue 컴포넌트
//
// hot-fix #20 안건 21 (2026-05-08) — 명명 변경: breadcrumb → page-header (사용자 결정 옵션 B):
//   · 안건 17 trail 제거 후 본 컴포넌트의 의미 = "페이지명 + 메뉴 active icon" 단독 노출 = 페이지 헤더
//   · breadcrumb (경로 navigation) 라는 명칭이 동작 의미와 안 맞음 → page-header 로 rename
//   · 동작은 그대로 (rename 만)
//
// hot-fix #20 안건 15·17 (2026-05-08) — 디자인 단순화:
//   · trail (region › middle path) 제거 — 사이드바 + 서브헤더와 중복 (사용자 결정)
//   · 좌측 큰 헤딩 (h1) + 메뉴 active icon 자동 노출 — 시각 일관성 ↑
//
// M6 결정 + Step 5 검토 2 β — 페이지명 부분에 <h1> 태그 부여 (SEO·접근성 보존)
//
// props:
//   pageTitle (String|null)    — 페이지명 (h1 으로 표시)
//   pageIcon (String|null)     — 메뉴 active 의 icon (material-icons 이름 또는 img URL)
//   pageIconType (String|null) — 'material' / 'img'
//   pageUrl (String|null)      — 안건 83 (2026-05-14): 페이지 헤딩 클릭 시 진입할 메뉴 기본 URL (검색 필터 미적용 기본 조회)
export default {
    name: 'app-page-header',
    props: {
        pageTitle: {
            type: String,
            default: null,
        },
        pageIcon: {
            type: String,
            default: null,
        },
        pageIconType: {
            type: String,
            default: null,
        },
        pageUrl: {
            type: String,
            default: null,
        },
    },
};
</script>

<style scoped>
.ref020-page-header {
    /* 단순화 (안건 17): 큰 헤딩만 노출, trail 제거 */
    display: flex;
    align-items: center;
    padding: 0.875rem 1.25rem;
    background: #fff;
    border-bottom: 1px solid #e5e7eb;
}
.ref020-page-header-title {
    /* h1 — 큰 헤딩 + 좌측 icon (메뉴 active 자동) */
    display: inline-flex;
    align-items: center;
    gap: 0.5rem;
    margin: 0;
    padding: 0;
    font-size: 1.5rem;
    font-weight: 700;
    color: #111827;
    line-height: 1.3;
    letter-spacing: -0.01em;
}
.ref020-page-header-icon-mat {
    font-size: 1.625rem;
    color: #4b5563;
}
.ref020-page-header-icon-img {
    width: 22px;
    height: auto;
}
.ref020-page-header-text {
    /* 별도 span — icon 과 align-items center */
}
/* 안건 83 (2026-05-14): 페이지 헤딩 클릭 — 메뉴 기본 URL 진입 (검색 필터 초기화).
   기본 색상 inherit (h1 의 #111827). hover 시 살짝 진한 파랑 + underline (anchor 인지). */
.ref020-page-header-link {
    display: inline-flex;
    align-items: center;
    gap: 0.5rem;
    color: inherit;
    text-decoration: none;
    transition: color 0.15s;
}
.ref020-page-header-link:hover {
    color: #1d4ed8;
    text-decoration: underline;
}
.ref020-page-header-link:hover .ref020-page-header-icon-mat {
    color: #1d4ed8;
}
</style>
